/* eslint-disable */
import React from 'react';
import { formatMoney } from '@meterup/atto';
import cx from 'classnames';
import styles from './FormattedMonthlyAmount.module.css';
import { Quote } from '@meterup/connect-api';

export const PreDiscountMonthlyAmount: React.FunctionComponent<{ amount: number }> = ({
  amount,
}) => {
  const formattedAmount = formatMoney({
    amount: Math.ceil(amount / 100),
    hideCentsIfZero: true,
  });
  const [roundedAmount, cents] = formattedAmount.toString().split('.');
  return (
    <div className="relative pr-2">
      <span className="inline-block text-gray-300">{roundedAmount}</span>
      <sup
        className={cx('font-normal text-gray-300 ml-nudge-2px inline-block self-top', styles.sup)}
      >
        {cents}
      </sup>
      <svg
        className="absolute inset-0 w-full h-full pointer-events-none"
        viewBox="0 0 100 100"
        preserveAspectRatio="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <line
          x1="5"
          y1="85"
          x2="85"
          y2="15"
          stroke="#1e202e"
          stroke-width="6"
          stroke-linecap="round"
        />
      </svg>
    </div>
  );
};

export const FormattedQuoteMonthlyAmount: React.FunctionComponent<{ quote: Quote }> = ({
  quote,
}) => {
  const formattedAmount = formatMoney({
    amount: Math.ceil(quote.monthlyFeeCents / 100),
    hideCentsIfZero: true,
  });
  const [roundedAmount, cents] = formattedAmount.toString().split('.');

  return (
    <div className="text-gray-800 inline-block flex items-center">
      <span className="inline-block ">{roundedAmount}</span>
      <sup
        className={cx('font-normal text-gray-700 ml-nudge-2px inline-block self-top', styles.sup)}
      >
        {cents}
      </sup>

      <span className={cx('font-normal text-gray-600 ml-1 inline-block', styles.monthlyAddon)}>
        /mo
      </span>
    </div>
  );
};

export const FormattedQuoteMonthlyAmountSimple: React.FunctionComponent<{ quote: Quote }> = ({
  quote,
}) =>
  formatMoney({
    amount: Math.ceil(quote.monthlyFeeCents / 100),
    hideCentsIfZero: true,
  });
